import Styles from './FormButtons.module.scss';
import { AiOutlineLoading } from 'react-icons/ai';

const FormButtons = ({ loading, onSubmit, onCancel, isEdit = false }) => {

  return (
    <div className={`${Styles.buttons}`}>
      <button
        type="button"
        onClick={onSubmit}
        disabled={loading}
        style={{
          opacity: loading ? 0.6 : 1,
          cursor: loading ? 'not-allowed' : 'pointer',
        }}
      >
        {loading ? (
          <AiOutlineLoading className={`${Styles.spinner}`} />
        ) : (
          isEdit ? "Update" : "Create"
        )}
      </button>
      <button type="button" onClick={onCancel}>
        Cancel
      </button>
    </div>
  );
};

export default FormButtons;